module.exports = __webpack_public_path__ + "static/WaitingRoom-642edfa2c0ffd7ad5b9b9a04b0913bb2.svg";